import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import SectionIntro from '../../../molecules/SectionIntro';

interface StepProps {
  number: number;
  title: string;
  description: string;
}

const Step: React.FC<StepProps> = ({ number, title, description }) => (
  <div className="flex gap-4 mb-8 last:mb-0">
    <div className="flex-shrink-0">
      <div className="w-10 h-10 rounded-full bg-[#fbe4dc] flex items-center justify-center">
        <span className="font-serif text-[#e55425] font-semibold">
          {number}
        </span>
      </div>
    </div>
    <div>
      <h3 className="font-serif text-lg font-medium text-[#1c1c1c] mb-2">
        {title}
      </h3>
      <p className="text-[15px] text-[#1c1c1c]/65 leading-relaxed">
        {description}
      </p>
    </div>
  </div>
);

const HomeHowItWorks = () => {
  const { t } = useTranslation('common');
  return (
    <section className="bg-white py-16 md:py-24">
      <div id="how-it-works-container">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-5xl lg:px-8">
          <SectionIntro
            title={t('service.home.howItWorks.title')}
            intro={t('service.home.howItWorks.intro')}
          />
          <div className="mt-8 pb-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <div className="rounded-xl overflow-hidden bg-[#f8f5f0]">
                  <Image
                    width={575}
                    height={380}
                    className="w-full h-auto object-cover"
                    src="/images/ogImg.png"
                    alt="Classroom Image"
                  />
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <Step
                  number={1}
                  title={t('service.home.howItWorks.step1.title')}
                  description={t('service.home.howItWorks.step1.paragraph')}
                />
                <Step
                  number={2}
                  title={t('service.home.howItWorks.step2.title')}
                  description={t('service.home.howItWorks.step2.paragraph')}
                />
                <Step
                  number={3}
                  title={t('service.home.howItWorks.step3.title')}
                  description={t('service.home.howItWorks.step3.paragraph')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default HomeHowItWorks;
